import MuiMenuItem from '@mui/material/MenuItem';
import { alpha, type SxProps, type Theme } from '@mui/material/styles';
import type { AriaAttributes, ReactNode } from 'react';
import { NAV_CURRENT_ALPHA } from '../../theme/interaction';

export interface MenuItemProps extends Pick<AriaAttributes, 'aria-checked'> {
  onClick?: () => void;
  role?: string;
  // Visual tint only — assistive tech learns nothing from it. Pair with aria-checked.
  selected?: boolean;
  children?: ReactNode;
}

// MUI stacks the focus opacity on the selection tint (20 %), where a primary label drops below AA.
// Capped at the navigation's 12 %: focus still reads, 8 % → 12 %, and the label keeps AA.
const selectedSx: SxProps<Theme> = (theme) => ({
  '&.Mui-selected.Mui-focusVisible, &.Mui-selected:hover': {
    backgroundColor: alpha(theme.palette.primary.main, NAV_CURRENT_ALPHA),
  },
});

export function MenuItem({
  onClick,
  role,
  selected,
  children,
  // Which mode is active, for a menu picking one of a set. aria-selected is unsupported on a
  // menu item, so role="menuitemradio" + this is the only route; a ✓ glyph has no text alternative.
  ...aria
}: MenuItemProps) {
  return (
    <MuiMenuItem
      sx={selectedSx}
      {...(onClick ? { onClick } : {})}
      {...(role !== undefined ? { role } : {})}
      {...(selected !== undefined ? { selected } : {})}
      {...aria}
    >
      {children}
    </MuiMenuItem>
  );
}
